// GA4 Events
const add_to_datalayer = async (payload) => {
    const dataLayer = {
        ...payload
    }
    window?.dataLayer?.push(dataLayer);
}

export { add_to_datalayer };